import { render, staticRenderFns } from "./Teen14.vue?vue&type=template&id=be5b228e&scoped=true&"
import script from "./Teen14.vue?vue&type=script&lang=js&"
export * from "./Teen14.vue?vue&type=script&lang=js&"
import style0 from "./Teen14.vue?vue&type=style&index=0&id=be5b228e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5b228e",
  null
  
)

export default component.exports